<template>
  <div>
    <v-text-field
      label="Hesap Adı"
      v-model="localData.accountName"
      required
      @input="emitUpdate"
    />
    <small style="color: #98a2b3; font-size: 11px; margin-top: -5px;">
      Ticari Ünvanla Aynı Olmalı
    </small>
    <v-text-field
      label="IBAN"
      v-mask="'TR## #### #### #### #### #### ##'"
      v-model="localData.iban"
      required
      @input="onIbanChange($event)"
      maxlength="32"
    />
    <v-text-field
      label="Banka Adı"
      v-model="localData.bankName"
      required
      readonly
    />
    <small style="color: #98a2b3; font-size: 11px; margin-top: -5px;">
      Bu alan IBAN alanı doldurulduğunda otomatik olarak gelecektir.
    </small>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BankInfoForm',
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData },
    }
  },
  watch: {
    formData: {
      deep: true,
      handler(newData) {
        this.localData = { ...newData }
      },
    },
  },
  computed: {
    ...mapGetters('applyMerchantForm'),
  },
  methods: {
    ...mapActions('applyMerchantForm', ['fetchBankNameByIban']),
    emitUpdate() {
      this.$emit('update-form-data', 'bankInfo', this.localData)
    },
    onIbanChange(iban) {
      if (!iban.startsWith('TR')) {
        iban = 'TR' + iban.replace(/^TR/, '') // Kullanıcı TR'yi silerse ekle
      }

      this.localData.iban = iban

      const trimmedIban = iban.replaceAll(' ', '')
      if (trimmedIban.length === 26) {
        this.fetchBankNameByIban(trimmedIban).then((res) => {
          if (res.processStatus === 'Success') {
            this.localData.bankName = res.payload.bankName
          }
          this.$nextTick(() => {
            this.emitUpdate()
          })
        })
      } else if (this.localData.bankName !== '') {
        this.localData.bankName = ''
        this.$nextTick(() => {
          this.emitUpdate()
        })
      } else {
        this.emitUpdate()
      }
    },
  },
}
</script>
